import {
    SPI,
    FormFieldWidget,
    ViewType,
    ModelFieldType,
    SearchM2OMultiSelectFieldWidget,
    Widget
} from '@kunlun/dependencies';
import { isEmpty } from 'lodash-es';

@SPI.ClassFactory(
    FormFieldWidget.Token({
        viewType: ViewType.Search,
        ttype: ModelFieldType.ManyToOne,
        widget: 'MultiSelect'
    })
)
export class KeepInputMultiDropdown extends SearchM2OMultiSelectFieldWidget {
    public initialize(props) {
        super.initialize(props);
        return this;
    }
    @Widget.Method()
    public change(value) {

        if (value == null) {
            super.change(value);
            this.handleEmpty();
        } else {
            if (!value.length) {
                this.handleEmpty();
            }
            // focus的时候才会查询数据，这时候dataList为空，如果开始有value，会导致剩下的已选数据匹配不到值
            //  this.dataList.concat(this.value ?? []) 防止清空已选值
            const list = isEmpty(this.dataList) ? this.value || [] : this.dataList.concat(this.value ?? []);
            const submitData = value
                .map((item) => {
                    return (list as any[])?.find((d) => d[this.relationFieldKey] === item.value);
                })
                .filter((a) => !!a);
            super.updateValue(submitData);
        }
    }
}
